import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialOrderLinesFilterData,
  InitialOrderLinesFilterDataVariables
} from "./types/InitialOrderLinesFilterData";
import { orderLines, orderLinesVariables } from "./types/orderLines";
import {
  orderLinesDownload,
  orderLinesDownloadVariables
} from "./types/orderLinesDownload";

export const orderLinesListQuery = gql`
  ${pageInfoFragment}
  query orderLines(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: OrderLinesFilterInput!
  ) {
    orderLines(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          sku_level_status
          order_date
          store_order_code
          product_name
          quantity
          price_paid
        }
      }
    }
  }
`;

export const useOrderLinesListQuery = makeBossQuery<
  orderLines,
  orderLinesVariables
>(orderLinesListQuery);

export const orderLinesDownloadQuery = gql`
  ${pageInfoFragment}
  query orderLinesDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: OrderLinesFilterInput!
  ) {
    orderLines(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          sku_level_status
          order_date
          order_code
          store_order_code
          product_sku
          product_name
          variant_name
          quantity
          retail_price
          sales_discount_total
          selling_price
          price_paid
          purchase_type
          first_purchase
          sales_discount_sm
          sales_discount_tenant
        }
      }
    }
  }
`;
export const useOrderLinesDownloadQuery = makeBossQuery<
  orderLinesDownload,
  orderLinesDownloadVariables
>(orderLinesDownloadQuery);

export const initialOrderLinesFilterDataQuery = gql`
  query InitialOrderLinesFilterData($brand: [ID], $mall: [ID]) {
    brands(first: 5, filter: { id: $brand }) {
      edges {
        node {
          id
          name
        }
      }
    }

    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialOrderLinesFilterDataQuery = makeQuery<
  InitialOrderLinesFilterData,
  InitialOrderLinesFilterDataVariables
>(initialOrderLinesFilterDataQuery);
